import React from 'react';
import { Helmet, HelmetProvider } from 'react-helmet-async';

type Props = {
    title: string;
    description?: string;
};

const Head = ( props: Props ) => {
    const { title, description } = props;

    return (
        <HelmetProvider { ...props }>
            <Helmet>
                <title>{`${title } | Genesis ES` || 'Genesis ES' }</title>
                { description && <meta name="description" content={ description } /> }
            </Helmet>
        </HelmetProvider>
    )
};

export default Head;